import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchService } from '../../services/search/search.service';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { Subscription, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EVENTS } from '@app/constants/events.constants';
import { relationshipStoreActions } from '@app/root-store';
import { UserConnectionService, UserService } from '@app/shared/services';
import { UserInviteComponent } from '../user-invite/user-invite.component';
import { UserInviteSuccessScreenComponent } from '@app/modules/relationship/components/dialogs/user-invite-success-screen/user-invite-success-screen.component';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { AddConnectionComponent } from '../add-connection-component/add-connection.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-connections-search',
  templateUrl: './connections-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionsSearchComponent implements OnInit, OnDestroy {
  searchInput = '';
  userInput = new UntypedFormControl('');
  delay = 300;
  searchResults = [];
  search_val = '';
  subscription = new Subscription();
  currentUser = null;
  connection_relationship_data: any = {};
  selectedRelationship = {
    id: 68,
    name: 'Client',
  };
  isLoading = false;
  searchText = '';
  @Input() placeholder = 'Search for users by name or email';
  @Input() isDialog = false;
  @Output() emitSelectedUser: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    @Optional() public dialogRef: MatDialogRef<ConnectionsSearchComponent>,
    private searchService: SearchService,
    private cd: ChangeDetectorRef,
    private store: Store,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _userService: UserService,
    private userConnectionService: UserConnectionService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.userInput.valueChanges
        .pipe(
          debounce(() => {
            this.isLoading = true;
            return interval(this.delay);
          })
        )
        .subscribe((value) => {
          this.isLoading = true;
          if (value.trim() == '') {
            this.searchResults = [];
            this.search_val = '';
            this.isLoading = false;
            return;
          } else {
            this.isLoading = true;
            this.search_val = value;
            const payload = {
              search_type: 'all',
              search_val: value,
              user_id: this.currentUser?.id,
            };
            this.subscription.add(
              this.searchService.search(payload).subscribe((res) => {
                const { data } = res;

                if (!!this.data) {
                  const { existingItems } = this.data;
                  if (!!existingItems || (this.data?.existingUsers && (this.data?.fromAddVault || this.data?.fromLinkedTemplate))) {
                    const isNotInArrayA =
                      !this.data?.fromAddVault && !this.data?.fromLinkedTemplate
                        ? (itemB) => !existingItems.some((item) => item.user_id === itemB.user_id)
                        : (itemB) => !this.data?.existingUsers.some((item) => item.user_id === itemB.user_id);
                    let filtered = data.filter(isNotInArrayA);

                    if (!this.data?.fromLinkedTemplate) {
                      filtered = filtered.filter((item) => {
                        if (!item.relationship_name) return item;
                      });
                    }
                    const newList = this.data.user_type
                      ? filtered.filter((item) =>
                          this.data.user_type == UserTypeEnum.Professional
                            ? item.user_type == UserTypeEnum.Professional
                            : item.user_type != UserTypeEnum.Professional
                        )
                      : filtered;
                    this.searchResults = newList;
                  } else {
                    this.searchResults = this.data.user_type
                      ? data.filter((item) =>
                          this.data.user_type == UserTypeEnum.Professional
                            ? item.user_type == UserTypeEnum.Professional
                            : item.user_type != UserTypeEnum.Professional
                        )
                      : data;
                  }
                } else {
                  this.searchResults = data.filter((item) => {
                    if (!item.relationship_name) return item;
                  });
                }
                const removeDuplicates = this.searchResults.filter(
                  (item, index, self) => index === self.findIndex((t) => t.user_id === item.user_id)
                );

                let filtered = [];
                removeDuplicates.forEach((element) => {
                  if (!this.data.existingUsers.some((u) => u.user_id === element.user_id)) {
                    filtered.push(element);
                  }
                });
                // const filtered = removeDuplicates.filter((user) => new Set(this.data.existingUsers.map((u) => u.user_id)).has(user.user_id));
                this.searchResults = filtered;
                this.isLoading = false;
                this.cd.detectChanges();
              })
            );
          }

          this.isLoading = false;
        })
    );
  }
  closeDialog(user?: Record<any, any>) {
    this.dialogRef.close(user);
  }
  clearSearch() {
    this.searchInput = '';
    this.search_val = '';
    this.searchResults = [];
    this.userInput.setValue('');
    this.isLoading = false;
    this.cd.detectChanges();
  }
  handleRelationshipSearch(val) {
    this.searchText = val;
  }
  selectedUser = null;
  selectUser(user) {
    if (user?.relationship_name) {
      const expectedPayload = {
        isexistingUser: true,
        success: true,
        relationship_name: user?.relationship_name,
        relationship_id: user?.relationship_id,
        user_id: user?.user_id,
        id: user?.user_id,
        name: `${user?.user_first_name + ' ' + user?.user_last_name}`,
        user_profile_image_url: user?.user_profile_image_url,
        connection_status: user?.connection_status,
      };
      if (this.isDialog) {
        this.emitSelectedUser.emit(user);
        this.clearSearch();
        return;
      }
      this.closeDialog(expectedPayload);
    } else {
      this.selectedUser = user;
      // if (this.data?.fromAddVault || this.data?.fromLinkedTemplate) this.dialogRef.close(this.selectedUser);
      this.searchResults = [];
      this.search_val = '';
      this.searchText = '';
      if (this.isDialog) {
        this.emitSelectedUser.emit(user);
        this.clearSearch();
        return;
      }
      this.cd.detectChanges();
    }
  }
  clearUser() {
    this.selectedUser = null;
    this.searchInput = '';
    this.search_val = '';
    this.userInput.setValue('');
  }
  selectedRelationshipData;
  doSomething(selectedData) {
    selectedData.id ? (this.selectedRelationshipData = selectedData) : (this.selectedRelationshipData = null);
  }
  relationshipIdChanged(event) {
    return;
  }
  connectUser() {
    if (!this.selectedRelationshipData) return;
    const finaldata = {
      relationship_name: this.selectedRelationshipData.name,
      to_user_id: this.selectedUser?.user_id,
      user_id: this.currentUser?.id,
      requested_user_id: this.selectedUser?.user_id,
      relationship_id: this.selectedRelationshipData.id,
    };
    // if (params?.user?.user_type == UserTypeEnum.Professional && this.current_user['user_type'] != UserTypeEnum.Professional) {
    //   finaldata['relationship_id'] = ClientUserRelationship.id;
    //   finaldata['relationship_name'] = ClientUserRelationship.name;
    // }
    this.subscription.add(
      this.userConnectionService.connectToUser(finaldata).subscribe(
        (res) => {
          this.store.dispatch(new relationshipStoreActions.AllRelationships());
          // if (!this.isInvite) {
          const data = {
            isexistingUser: true,
            success: true,
            ...finaldata,
            FullName: this.selectedUser?.user_first_middle_name + ' ' + this.selectedUser?.user_last_name,
          };
          this.subscription.add(this.userConnectionService.sendRelationshipRequestNotification(finaldata).subscribe());
          if (this.data?.requestForAddedUserData) {
            delete data.user_id;
            delete data.FullName;
            data['user_id'] = this.selectedUser?.user_id;
            data['name'] = this.selectedUser?.user_first_name + ' ' + this.selectedUser?.user_last_name;
            data['user_profile_image_url'] = this.selectedUser?.user_profile_image_url;
          }
          this.dialogRef.close(data);
          this.trackEventsInMixPanel();
          // } else {
          //   this.dialogRef.close();
          // }
        },
        (error) => {}
      )
    );
  }
  inviteUser() {
    this.userInput.setValue('');
    const modalRef3 = this.dialog.open(UserInviteComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe(
        (res) => {
          if (res && res['success'] == true) {
            if (res['isexistingUser']) {
              this.toastr.success(`Connection request has been sent to ${res.FullName}`);
            } else {
              const modalRef = this.dialog.open(UserInviteSuccessScreenComponent, {
                autoFocus: false,
                panelClass: 'full-window-dialog-2',
                data: res,
              });
            }
          }
        },
        (error) => {}
      )
    );
  }

  // openInviteDialog() {
  //   this.modalService.open(UserInviteComponent);
  // }

  trackEventsInMixPanel() {
    const events =
      this.data?.type === 'Immediate Family Members'
        ? [{ eventName: EVENTS.network_setup_immediate_family_add_change }]
        : this.data?.type === 'In-Laws'
        ? [{ eventName: EVENTS.network_setup_in_laws_add_change }]
        : this.data?.type === 'Extended Family Members'
        ? [{ eventName: EVENTS.network_setup_extended_family_add_change }]
        : this.data?.type === 'Other Relationships'
        ? [{ eventName: EVENTS.network_setup_other_relationship_add_change }]
        : this.data?.type === 'Service Providers'
        ? [{ eventName: EVENTS.network_setup_service_providers_add_change }]
        : this.data?.type === 'Staff'
        ? [{ eventName: EVENTS.network_setup_staff_add_change }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
  openInvite() {
    const modalRef3 = this.dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: {
        fromAddVault: true,
        fromSharing: true,
        custom_user_type: this.data?.user_type && this.data?.user_type === 'professional' ? UserTypeEnum.Professional : '',
      },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe((res) => {
        if (res) {
          const itemData = {
            ...res,
            ...(!res.user_id && { user_id: res.id }),
            ...(!res?.connection_status && { connection_status: 'invited' }),
          };
          this.emitSelectedUser.emit(itemData);
          this.cd.detectChanges();
        }
      })
    );
  }
}
